// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bddcfb4c","453":"b077c77a","455":"0d000d8b","977":"7259b472"}[chunkId] + ".chunk.js";
};